import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "../../../design/dialog";
import EmptyStateView from "../../EmptyStateView";
import { Table, TableBody } from "../../../design/table";
import { useUser } from "../../../contexts/UserContext";
import { User } from "../../../models/User";
import SelectUserListItem from "./SelectUserListItem";
import { useMatter } from "../../../contexts/MatterContext";

interface SelectUserDialogProps {
  isOpen: boolean;
  onUserSelected: (user: User) => void;
  onClose: () => void;
}

const SelectUserDialog: React.FC<SelectUserDialogProps> = ({
  isOpen,
  onClose,
  onUserSelected,
}) => {
  const { currentMatter } = useMatter();
  const users = currentMatter?.users ?? [];

  return (
    <>
      <Dialog open={isOpen} onClose={onClose}>
        <DialogTitle className="flex items-center justify-between">
          Select User
        </DialogTitle>
        <DialogBody>
          {users.length === 0 && (
            <EmptyStateView
              title="No Users"
              message="You don't have any users yet."
            />
          )}
          {users.length > 0 && (
            <Table>
              <TableBody>
                {users.map((user) => (
                  <SelectUserListItem
                    key={user._id}
                    user={user}
                    onClick={() => onUserSelected(user)}
                  />
                ))}
              </TableBody>
            </Table>
          )}
        </DialogBody>
        <DialogActions className="justify-between"></DialogActions>
      </Dialog>
    </>
  );
};

export default SelectUserDialog;
